import { MenuItemProps } from './SideMenuItem';

export const fixItems = (items: MenuItemProps[] = []): MenuItemProps[] => {
  if (!items.length) {
    return [];
  }

  const activeItems = items.filter((item) => item.active);

  if (activeItems.length < 1) {
    return items;
  }

  // there must be a maximum of 1 active item
  const singleActiveItem = activeItems.reduce((prev) => {
    return {
      ...prev,
    };
  });

  const fixedItems = items.map((item) => {
    if (item.active && JSON.stringify(item) !== JSON.stringify(singleActiveItem)) {
      item.active = false;
    }

    return item;
  });

  return fixedItems;
};
